export class EpimsBaseEntityDto {
	id: string;
	SubscriberId: string;
  SiteId: string;
  dateCreated?: Date;
	dateUpdated?: Date;
	ModifiedById: string;
	CreatedById?: string;
}
